// Places365 Room Type Translations
// Auto-generated from https://github.com/csailvision/places365

export const roomTypesEN: Record<string, string> = {
  "Airfield": "Airfield",
  "Airplane Cabin": "Airplane Cabin",
  "Airport Terminal": "Airport Terminal",
  "Alcove": "Alcove",
  "Alley": "Alley",
  "Amphitheater": "Amphitheater",
  "Amusement Arcade": "Amusement Arcade",
  "Amusement Park": "Amusement Park",
  "Apartment Building Outdoor": "Apartment Building",
  "Aquarium": "Aquarium",
  "Aqueduct": "Aqueduct",
  "Arcade": "Arcade",
  "Arch": "Arch",
  "Archaelogical Excavation": "Archaeological Excavation",
  "Archive": "Archive",
  "Arena Hockey": "Hockey Arena",
  "Arena Performance": "Performance Arena",
  "Arena Rodeo": "Rodeo Arena",
  "Army Base": "Army Base",
  "Art Gallery": "Art Gallery",
  "Art School": "Art School",
  "Art Studio": "Art Studio",
  "Artists Loft": "Artist's Loft",
  "Assembly Line": "Assembly Line",
  "Athletic Field Outdoor": "Athletic Field",
  "Atrium Public": "Atrium",
  "Attic": "Attic",
  "Auditorium": "Auditorium",
  "Auto Factory": "Auto Factory",
  "Auto Showroom": "Auto Showroom",
  "Badlands": "Badlands",
  "Bakery Shop": "Bakery",
  "Balcony Exterior": "Balcony",
  "Balcony Interior": "Balcony",
  "Ball Pit": "Ball Pit",
  "Ballroom": "Ballroom",
  "Bamboo Forest": "Bamboo Forest",
  "Bank Vault": "Bank Vault",
  "Banquet Hall": "Banquet Hall",
  "Bar": "Bar",
  "Barn": "Barn",
  "Barndoor": "Barn Door",
  "Baseball Field": "Baseball Field",
  "Basement": "Basement",
  "Basketball Court Indoor": "Basketball Court",
  "Bathroom": "Bathroom",
  "Bazaar Indoor": "Bazaar",
  "Bazaar Outdoor": "Bazaar",
  "Beach": "Beach",
  "Beach House": "Beach House",
  "Beauty Salon": "Beauty Salon",
  "Bedchamber": "Bedchamber",
  "Bedroom": "Bedroom",
  "Beer Garden": "Beer Garden",
  "Beer Hall": "Beer Hall",
  "Berth": "Berth",
  "Biology Laboratory": "Biology Laboratory",
  "Boardwalk": "Boardwalk",
  "Boat Deck": "Boat Deck",
  "Boathouse": "Boathouse",
  "Bookstore": "Bookstore",
  "Booth Indoor": "Booth",
  "Botanical Garden": "Botanical Garden",
  "Bow Window Indoor": "Bow Window",
  "Bowling Alley": "Bowling Alley",
  "Boxing Ring": "Boxing Ring",
  "Bridge": "Bridge",
  "Building Facade": "Building Facade",
  "Bullring": "Bullring",
  "Burial Chamber": "Burial Chamber",
  "Bus Interior": "Bus Interior",
  "Bus Station Indoor": "Bus Station",
  "Butchers Shop": "Butcher Shop",
  "Butte": "Butte",
  "Cabin Outdoor": "Cabin",
  "Cafeteria": "Cafeteria",
  "Campsite": "Campsite",
  "Campus": "Campus",
  "Canal Natural": "Canal",
  "Canal Urban": "Canal",
  "Candy Store": "Candy Store",
  "Canyon": "Canyon",
  "Car Interior": "Car Interior",
  "Carrousel": "Carousel",
  "Castle": "Castle",
  "Catacomb": "Catacomb",
  "Cemetery": "Cemetery",
  "Chalet": "Chalet",
  "Chemistry Lab": "Chemistry Lab",
  "Childs Room": "Child's Room",
  "Church Indoor": "Church",
  "Church Outdoor": "Church",
  "Classroom": "Classroom",
  "Clean Room": "Clean Room",
  "Cliff": "Cliff",
  "Closet": "Closet",
  "Clothing Store": "Clothing Store",
  "Coast": "Coast",
  "Cockpit": "Cockpit",
  "Coffee Shop": "Coffee Shop",
  "Computer Room": "Computer Room",
  "Conference Center": "Conference Center",
  "Conference Room": "Conference Room",
  "Construction Site": "Construction Site",
  "Corn Field": "Corn Field",
  "Corral": "Corral",
  "Corridor": "Corridor",
  "Cottage": "Cottage",
  "Courthouse": "Courthouse",
  "Courtyard": "Courtyard",
  "Creek": "Creek",
  "Crevasse": "Crevasse",
  "Crosswalk": "Crosswalk",
  "Dam": "Dam",
  "Delicatessen": "Delicatessen",
  "Department Store": "Department Store",
  "Desert Sand": "Desert",
  "Desert Vegetation": "Desert",
  "Desert Road": "Desert Road",
  "Diner Outdoor": "Diner",
  "Dining Hall": "Dining Hall",
  "Dining Room": "Dining Room",
  "Discotheque": "Discotheque",
  "Doorway Outdoor": "Doorway",
  "Dorm Room": "Dorm Room",
  "Downtown": "Downtown",
  "Dressing Room": "Dressing Room",
  "Driveway": "Driveway",
  "Drugstore": "Drugstore",
  "Elevator Door": "Elevator",
  "Elevator Lobby": "Elevator Lobby",
  "Elevator Shaft": "Elevator Shaft",
  "Embassy": "Embassy",
  "Engine Room": "Engine Room",
  "Entrance Hall": "Entrance Hall",
  "Escalator Indoor": "Escalator",
  "Excavation": "Excavation",
  "Fabric Store": "Fabric Store",
  "Farm": "Farm",
  "Fastfood Restaurant": "Fast Food Restaurant",
  "Field Cultivated": "Cultivated Field",
  "Field Wild": "Field",
  "Field Road": "Field Road",
  "Fire Escape": "Fire Escape",
  "Fire Station": "Fire Station",
  "Fishpond": "Fishpond",
  "Flea Market Indoor": "Flea Market",
  "Florist Shop Indoor": "Florist Shop",
  "Food Court": "Food Court",
  "Football Field": "Football Field",
  "Forest Broadleaf": "Forest",
  "Forest Path": "Forest Path",
  "Forest Road": "Forest Road",
  "Formal Garden": "Formal Garden",
  "Fountain": "Fountain",
  "Galley": "Galley",
  "Garage Indoor": "Garage",
  "Garage Outdoor": "Garage",
  "Gas Station": "Gas Station",
  "Gazebo Exterior": "Gazebo",
  "General Store Indoor": "General Store",
  "General Store Outdoor": "General Store",
  "Gift Shop": "Gift Shop",
  "Glacier": "Glacier",
  "Golf Course": "Golf Course",
  "Greenhouse Indoor": "Greenhouse",
  "Greenhouse Outdoor": "Greenhouse",
  "Grotto": "Grotto",
  "Gymnasium Indoor": "Gymnasium",
  "Hangar Indoor": "Hangar",
  "Hangar Outdoor": "Hangar",
  "Harbor": "Harbor",
  "Hardware Store": "Hardware Store",
  "Hayfield": "Hayfield",
  "Heliport": "Heliport",
  "Highway": "Highway",
  "Home Office": "Home Office",
  "Home Theater": "Home Theater",
  "Hospital": "Hospital",
  "Hospital Room": "Hospital Room",
  "Hot Spring": "Hot Spring",
  "Hotel Outdoor": "Hotel",
  "Hotel Room": "Hotel Room",
  "House": "House",
  "Hunting Lodge Outdoor": "Hunting Lodge",
  "Ice Cream Parlor": "Ice Cream Parlor",
  "Ice Floe": "Ice Floe",
  "Ice Shelf": "Ice Shelf",
  "Ice Skating Rink Indoor": "Ice Skating Rink",
  "Ice Skating Rink Outdoor": "Ice Skating Rink",
  "Iceberg": "Iceberg",
  "Igloo": "Igloo",
  "Industrial Area": "Industrial Area",
  "Inn Outdoor": "Inn",
  "Islet": "Islet",
  "Jacuzzi Indoor": "Jacuzzi",
  "Jail Cell": "Jail Cell",
  "Japanese Garden": "Japanese Garden",
  "Jewelry Shop": "Jewelry Shop",
  "Junkyard": "Junkyard",
  "Kasbah": "Kasbah",
  "Kennel Outdoor": "Kennel",
  "Kindergarden Classroom": "Kindergarten Classroom",
  "Kitchen": "Kitchen",
  "Lagoon": "Lagoon",
  "Lake Natural": "Lake",
  "Landfill": "Landfill",
  "Landing Deck": "Landing Deck",
  "Laundromat": "Laundromat",
  "Lawn": "Lawn",
  "Lecture Room": "Lecture Room",
  "Legislative Chamber": "Legislative Chamber",
  "Library Indoor": "Library",
  "Library Outdoor": "Library",
  "Lighthouse": "Lighthouse",
  "Living Room": "Living Room",
  "Loading Dock": "Loading Dock",
  "Lobby": "Lobby",
  "Lock Chamber": "Lock Chamber",
  "Locker Room": "Locker Room",
  "Mansion": "Mansion",
  "Manufactured Home": "Manufactured Home",
  "Market Indoor": "Market",
  "Market Outdoor": "Market",
  "Marsh": "Marsh",
  "Martial Arts Gym": "Martial Arts Gym",
  "Mausoleum": "Mausoleum",
  "Medina": "Medina",
  "Mezzanine": "Mezzanine",
  "Moat Water": "Moat",
  "Mosque Outdoor": "Mosque",
  "Motel": "Motel",
  "Mountain": "Mountain",
  "Mountain Path": "Mountain Path",
  "Mountain Snowy": "Snowy Mountain",
  "Movie Theater Indoor": "Movie Theater",
  "Museum Indoor": "Museum",
  "Museum Outdoor": "Museum",
  "Music Studio": "Music Studio",
  "Natural History Museum": "Natural History Museum",
  "Nursery": "Nursery",
  "Nursing Home": "Nursing Home",
  "Oast House": "Oast House",
  "Ocean": "Ocean",
  "Office": "Office",
  "Office Building": "Office Building",
  "Office Cubicles": "Office Cubicles",
  "Oilrig": "Oil Rig",
  "Operating Room": "Operating Room",
  "Orchard": "Orchard",
  "Orchestra Pit": "Orchestra Pit",
  "Pagoda": "Pagoda",
  "Palace": "Palace",
  "Pantry": "Pantry",
  "Park": "Park",
  "Parking Garage Indoor": "Parking Garage",
  "Parking Garage Outdoor": "Parking Garage",
  "Parking Lot": "Parking Lot",
  "Pasture": "Pasture",
  "Patio": "Patio",
  "Pavilion": "Pavilion",
  "Pet Shop": "Pet Shop",
  "Pharmacy": "Pharmacy",
  "Phone Booth": "Phone Booth",
  "Physics Laboratory": "Physics Laboratory",
  "Picnic Area": "Picnic Area",
  "Pier": "Pier",
  "Pizzeria": "Pizzeria",
  "Playground": "Playground",
  "Playroom": "Playroom",
  "Plaza": "Plaza",
  "Pond": "Pond",
  "Porch": "Porch",
  "Promenade": "Promenade",
  "Pub Indoor": "Pub",
  "Racecourse": "Racecourse",
  "Raceway": "Raceway",
  "Raft": "Raft",
  "Railroad Track": "Railroad Track",
  "Rainforest": "Rainforest",
  "Reception": "Reception",
  "Recreation Room": "Recreation Room",
  "Repair Shop": "Repair Shop",
  "Residential Neighborhood": "Residential Neighborhood",
  "Restaurant": "Restaurant",
  "Restaurant Kitchen": "Restaurant Kitchen",
  "Restaurant Patio": "Restaurant Patio",
  "Rice Paddy": "Rice Paddy",
  "River": "River",
  "Rock Arch": "Rock Arch",
  "Roof Garden": "Roof Garden",
  "Rope Bridge": "Rope Bridge",
  "Ruin": "Ruin",
  "Runway": "Runway",
  "Sandbox": "Sandbox",
  "Sauna": "Sauna",
  "Schoolhouse": "Schoolhouse",
  "Science Museum": "Science Museum",
  "Server Room": "Server Room",
  "Shed": "Shed",
  "Shoe Shop": "Shoe Shop",
  "Shopfront": "Shopfront",
  "Shopping Mall Indoor": "Shopping Mall",
  "Shower": "Shower",
  "Ski Resort": "Ski Resort",
  "Ski Slope": "Ski Slope",
  "Sky": "Sky",
  "Skyscraper": "Skyscraper",
  "Slum": "Slum",
  "Snowfield": "Snowfield",
  "Soccer Field": "Soccer Field",
  "Stable": "Stable",
  "Stadium Baseball": "Baseball Stadium",
  "Stadium Football": "Football Stadium",
  "Stadium Soccer": "Soccer Stadium",
  "Stage Indoor": "Stage",
  "Stage Outdoor": "Stage",
  "Staircase": "Staircase",
  "Storage Room": "Storage Room",
  "Street": "Street",
  "Subway Station Platform": "Subway Station",
  "Supermarket": "Supermarket",
  "Sushi Bar": "Sushi Bar",
  "Swamp": "Swamp",
  "Swimming Hole": "Swimming Hole",
  "Swimming Pool Indoor": "Swimming Pool",
  "Swimming Pool Outdoor": "Swimming Pool",
  "Synagogue Outdoor": "Synagogue",
  "Television Room": "Television Room",
  "Television Studio": "Television Studio",
  "Temple Asia": "Temple",
  "Throne Room": "Throne Room",
  "Ticket Booth": "Ticket Booth",
  "Topiary Garden": "Topiary Garden",
  "Tower": "Tower",
  "Toyshop": "Toy Shop",
  "Train Interior": "Train Interior",
  "Train Station Platform": "Train Station",
  "Tree Farm": "Tree Farm",
  "Tree House": "Tree House",
  "Trench": "Trench",
  "Tundra": "Tundra",
  "Underwater Ocean Deep": "Underwater",
  "Utility Room": "Utility Room",
  "Valley": "Valley",
  "Vegetable Garden": "Vegetable Garden",
  "Veterinarians Office": "Veterinarian's Office",
  "Viaduct": "Viaduct",
  "Village": "Village",
  "Vineyard": "Vineyard",
  "Volcano": "Volcano",
  "Volleyball Court Outdoor": "Volleyball Court",
  "Waiting Room": "Waiting Room",
  "Water Park": "Water Park",
  "Water Tower": "Water Tower",
  "Waterfall": "Waterfall",
  "Watering Hole": "Watering Hole",
  "Wave": "Wave",
  "Wet Bar": "Wet Bar",
  "Wheat Field": "Wheat Field",
  "Wind Farm": "Wind Farm",
  "Windmill": "Windmill",
  "Yard": "Yard",
  "Youth Hostel": "Youth Hostel",
  "Zen Garden": "Zen Garden",
  "Unknown": "Unknown"
};

export const roomTypesFR: Record<string, string> = {
  "Airfield": "Aérodrome",
  "Airplane Cabin": "Cabine d'avion",
  "Airport Terminal": "Terminal d'aéroport",
  "Alcove": "Alcôve",
  "Alley": "Ruelle",
  "Amphitheater": "Amphithéâtre",
  "Amusement Arcade": "Salle d'arcade",
  "Amusement Park": "Parc d'attractions",
  "Apartment Building Outdoor": "Immeuble d'appartements",
  "Aquarium": "Aquarium",
  "Aqueduct": "Aqueduc",
  "Arcade": "Arcade",
  "Arch": "Arche",
  "Archaelogical Excavation": "Fouille archéologique",
  "Archive": "Archive",
  "Arena Hockey": "Arène de hockey",
  "Arena Performance": "Arène de spectacle",
  "Arena Rodeo": "Arène de rodéo",
  "Army Base": "Base militaire",
  "Art Gallery": "Galerie d'art",
  "Art School": "École d'art",
  "Art Studio": "Atelier d'art",
  "Artists Loft": "Loft d'artiste",
  "Assembly Line": "Chaîne de montage",
  "Athletic Field Outdoor": "Terrain d'athlétisme",
  "Atrium Public": "Atrium",
  "Attic": "Grenier",
  "Auditorium": "Auditorium",
  "Auto Factory": "Usine automobile",
  "Auto Showroom": "Salle d'exposition automobile",
  "Badlands": "Terres arides",
  "Bakery Shop": "Boulangerie",
  "Balcony Exterior": "Balcon",
  "Balcony Interior": "Balcon",
  "Ball Pit": "Piscine à balles",
  "Ballroom": "Salle de bal",
  "Bamboo Forest": "Forêt de bambous",
  "Bank Vault": "Coffre-fort bancaire",
  "Banquet Hall": "Salle de banquet",
  "Bar": "Bar",
  "Barn": "Grange",
  "Barndoor": "Porte de grange",
  "Baseball Field": "Terrain de baseball",
  "Basement": "Sous-sol",
  "Basketball Court Indoor": "Terrain de basketball",
  "Bathroom": "Salle de bain",
  "Bazaar Indoor": "Bazar",
  "Bazaar Outdoor": "Bazar",
  "Beach": "Plage",
  "Beach House": "Maison de plage",
  "Beauty Salon": "Salon de beauté",
  "Bedchamber": "Chambre à coucher",
  "Bedroom": "Chambre",
  "Beer Garden": "Jardin à bière",
  "Beer Hall": "Brasserie",
  "Berth": "Couchette",
  "Biology Laboratory": "Laboratoire de biologie",
  "Boardwalk": "Promenade",
  "Boat Deck": "Pont de bateau",
  "Boathouse": "Hangar à bateaux",
  "Bookstore": "Librairie",
  "Booth Indoor": "Cabine",
  "Botanical Garden": "Jardin botanique",
  "Bow Window Indoor": "Bow-window",
  "Bowling Alley": "Bowling",
  "Boxing Ring": "Ring de boxe",
  "Bridge": "Pont",
  "Building Facade": "Façade de bâtiment",
  "Bullring": "Arène",
  "Burial Chamber": "Chambre funéraire",
  "Bus Interior": "Intérieur de bus",
  "Bus Station Indoor": "Gare routière",
  "Butchers Shop": "Boucherie",
  "Butte": "Butte",
  "Cabin Outdoor": "Cabane",
  "Cafeteria": "Cafétéria",
  "Campsite": "Camping",
  "Campus": "Campus",
  "Canal Natural": "Canal",
  "Canal Urban": "Canal",
  "Candy Store": "Confiserie",
  "Canyon": "Canyon",
  "Car Interior": "Intérieur de voiture",
  "Carrousel": "Carrousel",
  "Castle": "Château",
  "Catacomb": "Catacombe",
  "Cemetery": "Cimetière",
  "Chalet": "Chalet",
  "Chemistry Lab": "Laboratoire de chimie",
  "Childs Room": "Chambre d'enfant",
  "Church Indoor": "Église",
  "Church Outdoor": "Église",
  "Classroom": "Salle de classe",
  "Clean Room": "Salle blanche",
  "Cliff": "Falaise",
  "Closet": "Placard",
  "Clothing Store": "Magasin de vêtements",
  "Coast": "Côte",
  "Cockpit": "Cockpit",
  "Coffee Shop": "Café",
  "Computer Room": "Salle informatique",
  "Conference Center": "Centre de conférences",
  "Conference Room": "Salle de conférence",
  "Construction Site": "Chantier de construction",
  "Corn Field": "Champ de maïs",
  "Corral": "Corral",
  "Corridor": "Couloir",
  "Cottage": "Cottage",
  "Courthouse": "Palais de justice",
  "Courtyard": "Cour",
  "Creek": "Ruisseau",
  "Crevasse": "Crevasse",
  "Crosswalk": "Passage piéton",
  "Dam": "Barrage",
  "Delicatessen": "Épicerie fine",
  "Department Store": "Grand magasin",
  "Desert Sand": "Désert",
  "Desert Vegetation": "Désert",
  "Desert Road": "Route du désert",
  "Diner Outdoor": "Restaurant",
  "Dining Hall": "Salle à manger",
  "Dining Room": "Salle à manger",
  "Discotheque": "Discothèque",
  "Doorway Outdoor": "Entrée",
  "Dorm Room": "Dortoir",
  "Downtown": "Centre-ville",
  "Dressing Room": "Loge",
  "Driveway": "Allée",
  "Drugstore": "Pharmacie",
  "Elevator Door": "Ascenseur",
  "Elevator Lobby": "Hall d'ascenseur",
  "Elevator Shaft": "Cage d'ascenseur",
  "Embassy": "Ambassade",
  "Engine Room": "Salle des machines",
  "Entrance Hall": "Hall d'entrée",
  "Escalator Indoor": "Escalier mécanique",
  "Excavation": "Excavation",
  "Fabric Store": "Magasin de tissus",
  "Farm": "Ferme",
  "Fastfood Restaurant": "Restaurant rapide",
  "Field Cultivated": "Champ cultivé",
  "Field Wild": "Champ",
  "Field Road": "Chemin de campagne",
  "Fire Escape": "Sortie de secours",
  "Fire Station": "Caserne de pompiers",
  "Fishpond": "Étang à poissons",
  "Flea Market Indoor": "Marché aux puces",
  "Florist Shop Indoor": "Fleuriste",
  "Food Court": "Aire de restauration",
  "Football Field": "Terrain de football",
  "Forest Broadleaf": "Forêt",
  "Forest Path": "Sentier forestier",
  "Forest Road": "Route forestière",
  "Formal Garden": "Jardin à la française",
  "Fountain": "Fontaine",
  "Galley": "Cuisine de bateau",
  "Garage Indoor": "Garage",
  "Garage Outdoor": "Garage",
  "Gas Station": "Station-service",
  "Gazebo Exterior": "Gazebo",
  "General Store Indoor": "Épicerie générale",
  "General Store Outdoor": "Épicerie générale",
  "Gift Shop": "Boutique de cadeaux",
  "Glacier": "Glacier",
  "Golf Course": "Terrain de golf",
  "Greenhouse Indoor": "Serre",
  "Greenhouse Outdoor": "Serre",
  "Grotto": "Grotte",
  "Gymnasium Indoor": "Gymnase",
  "Hangar Indoor": "Hangar",
  "Hangar Outdoor": "Hangar",
  "Harbor": "Port",
  "Hardware Store": "Quincaillerie",
  "Hayfield": "Champ de foin",
  "Heliport": "Héliport",
  "Highway": "Autoroute",
  "Home Office": "Bureau à domicile",
  "Home Theater": "Home cinéma",
  "Hospital": "Hôpital",
  "Hospital Room": "Chambre d'hôpital",
  "Hot Spring": "Source chaude",
  "Hotel Outdoor": "Hôtel",
  "Hotel Room": "Chambre d'hôtel",
  "House": "Maison",
  "Hunting Lodge Outdoor": "Pavillon de chasse",
  "Ice Cream Parlor": "Glacier",
  "Ice Floe": "Banquise",
  "Ice Shelf": "Plateforme glaciaire",
  "Ice Skating Rink Indoor": "Patinoire",
  "Ice Skating Rink Outdoor": "Patinoire",
  "Iceberg": "Iceberg",
  "Igloo": "Igloo",
  "Industrial Area": "Zone industrielle",
  "Inn Outdoor": "Auberge",
  "Islet": "Îlot",
  "Jacuzzi Indoor": "Jacuzzi",
  "Jail Cell": "Cellule de prison",
  "Japanese Garden": "Jardin japonais",
  "Jewelry Shop": "Bijouterie",
  "Junkyard": "Casse",
  "Kasbah": "Kasbah",
  "Kennel Outdoor": "Chenil",
  "Kindergarden Classroom": "Salle de classe maternelle",
  "Kitchen": "Cuisine",
  "Lagoon": "Lagon",
  "Lake Natural": "Lac",
  "Landfill": "Décharge",
  "Landing Deck": "Pont d'atterrissage",
  "Laundromat": "Laverie automatique",
  "Lawn": "Pelouse",
  "Lecture Room": "Salle de cours",
  "Legislative Chamber": "Chambre législative",
  "Library Indoor": "Bibliothèque",
  "Library Outdoor": "Bibliothèque",
  "Lighthouse": "Phare",
  "Living Room": "Salon",
  "Loading Dock": "Quai de chargement",
  "Lobby": "Hall d'entrée",
  "Lock Chamber": "Écluse",
  "Locker Room": "Vestiaire",
  "Mansion": "Manoir",
  "Manufactured Home": "Maison préfabriquée",
  "Market Indoor": "Marché",
  "Market Outdoor": "Marché",
  "Marsh": "Marais",
  "Martial Arts Gym": "Salle d'arts martiaux",
  "Mausoleum": "Mausolée",
  "Medina": "Médina",
  "Mezzanine": "Mezzanine",
  "Moat Water": "Douves",
  "Mosque Outdoor": "Mosquée",
  "Motel": "Motel",
  "Mountain": "Montagne",
  "Mountain Path": "Sentier de montagne",
  "Mountain Snowy": "Montagne enneigée",
  "Movie Theater Indoor": "Cinéma",
  "Museum Indoor": "Musée",
  "Museum Outdoor": "Musée",
  "Music Studio": "Studio de musique",
  "Natural History Museum": "Muséum d'histoire naturelle",
  "Nursery": "Chambre d'enfant",
  "Nursing Home": "Maison de retraite",
  "Oast House": "Séchoir à houblon",
  "Ocean": "Océan",
  "Office": "Bureau",
  "Office Building": "Immeuble de bureaux",
  "Office Cubicles": "Bureaux cloisonnés",
  "Oilrig": "Plateforme pétrolière",
  "Operating Room": "Salle d'opération",
  "Orchard": "Verger",
  "Orchestra Pit": "Fosse d'orchestre",
  "Pagoda": "Pagode",
  "Palace": "Palais",
  "Pantry": "Garde-manger",
  "Park": "Parc",
  "Parking Garage Indoor": "Parking couvert",
  "Parking Garage Outdoor": "Parking",
  "Parking Lot": "Parking",
  "Pasture": "Pâturage",
  "Patio": "Patio",
  "Pavilion": "Pavillon",
  "Pet Shop": "Animalerie",
  "Pharmacy": "Pharmacie",
  "Phone Booth": "Cabine téléphonique",
  "Physics Laboratory": "Laboratoire de physique",
  "Picnic Area": "Aire de pique-nique",
  "Pier": "Jetée",
  "Pizzeria": "Pizzeria",
  "Playground": "Aire de jeux",
  "Playroom": "Salle de jeux",
  "Plaza": "Place",
  "Pond": "Étang",
  "Porch": "Porche",
  "Promenade": "Promenade",
  "Pub Indoor": "Pub",
  "Racecourse": "Hippodrome",
  "Raceway": "Circuit de course",
  "Raft": "Radeau",
  "Railroad Track": "Voie ferrée",
  "Rainforest": "Forêt tropicale",
  "Reception": "Réception",
  "Recreation Room": "Salle de loisirs",
  "Repair Shop": "Atelier de réparation",
  "Residential Neighborhood": "Quartier résidentiel",
  "Restaurant": "Restaurant",
  "Restaurant Kitchen": "Cuisine de restaurant",
  "Restaurant Patio": "Terrasse de restaurant",
  "Rice Paddy": "Rizière",
  "River": "Rivière",
  "Rock Arch": "Arche rocheuse",
  "Roof Garden": "Jardin sur le toit",
  "Rope Bridge": "Pont de corde",
  "Ruin": "Ruine",
  "Runway": "Piste",
  "Sandbox": "Bac à sable",
  "Sauna": "Sauna",
  "Schoolhouse": "École",
  "Science Museum": "Musée des sciences",
  "Server Room": "Salle des serveurs",
  "Shed": "Remise",
  "Shoe Shop": "Magasin de chaussures",
  "Shopfront": "Devanture de magasin",
  "Shopping Mall Indoor": "Centre commercial",
  "Shower": "Douche",
  "Ski Resort": "Station de ski",
  "Ski Slope": "Piste de ski",
  "Sky": "Ciel",
  "Skyscraper": "Gratte-ciel",
  "Slum": "Bidonville",
  "Snowfield": "Champ de neige",
  "Soccer Field": "Terrain de football",
  "Stable": "Écurie",
  "Stadium Baseball": "Stade de baseball",
  "Stadium Football": "Stade de football",
  "Stadium Soccer": "Stade de football",
  "Stage Indoor": "Scène",
  "Stage Outdoor": "Scène",
  "Staircase": "Escalier",
  "Storage Room": "Débarras",
  "Street": "Rue",
  "Subway Station Platform": "Station de métro",
  "Supermarket": "Supermarché",
  "Sushi Bar": "Bar à sushi",
  "Swamp": "Marécage",
  "Swimming Hole": "Trou de baignade",
  "Swimming Pool Indoor": "Piscine couverte",
  "Swimming Pool Outdoor": "Piscine",
  "Synagogue Outdoor": "Synagogue",
  "Television Room": "Salle de télévision",
  "Television Studio": "Studio de télévision",
  "Temple Asia": "Temple",
  "Throne Room": "Salle du trône",
  "Ticket Booth": "Guichet",
  "Topiary Garden": "Jardin topiaire",
  "Tower": "Tour",
  "Toyshop": "Magasin de jouets",
  "Train Interior": "Intérieur de train",
  "Train Station Platform": "Quai de gare",
  "Tree Farm": "Plantation d'arbres",
  "Tree House": "Cabane dans les arbres",
  "Trench": "Tranchée",
  "Tundra": "Toundra",
  "Underwater Ocean Deep": "Sous-marin",
  "Utility Room": "Buanderie",
  "Valley": "Vallée",
  "Vegetable Garden": "Potager",
  "Veterinarians Office": "Cabinet vétérinaire",
  "Viaduct": "Viaduc",
  "Village": "Village",
  "Vineyard": "Vignoble",
  "Volcano": "Volcan",
  "Volleyball Court Outdoor": "Terrain de volleyball",
  "Waiting Room": "Salle d'attente",
  "Water Park": "Parc aquatique",
  "Water Tower": "Château d'eau",
  "Waterfall": "Cascade",
  "Watering Hole": "Point d'eau",
  "Wave": "Vague",
  "Wet Bar": "Bar",
  "Wheat Field": "Champ de blé",
  "Wind Farm": "Parc éolien",
  "Windmill": "Moulin à vent",
  "Yard": "Cour",
  "Youth Hostel": "Auberge de jeunesse",
  "Zen Garden": "Jardin zen",
  "Unknown": "Inconnu"
};
